(() => {
  const currentParams = new URLSearchParams(window.location.search);
  const previewThemeId = currentParams.get('preview_theme_id');

  if (previewThemeId) {
    document.querySelectorAll('.collection-navigation-card[href]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      url.searchParams.set('preview_theme_id', previewThemeId);
      link.href = `${url.pathname}${url.search}`;
    });
  }

  const breadcrumbs = document.querySelectorAll('[data-navigation-breadcrumbs="collection"]');

  breadcrumbs.forEach((breadcrumb) => {
    const sourceUrl = currentParams.get('nav_source');
    const sourceTitle = currentParams.get('nav_title');
    const currentItem = breadcrumb.querySelector('[data-navigation-breadcrumb-current]');
    const existingParent = breadcrumb.querySelector('[data-navigation-breadcrumb-parent]');

    if (!sourceUrl || !sourceTitle || !currentItem || !sourceUrl.startsWith('/pages/')) return;

    const sourceItem = document.createElement('li');
    const separator = document.createElement('li');
    const link = document.createElement('a');

    sourceItem.className = 'navigation-breadcrumbs__item';
    separator.className = 'navigation-breadcrumbs__separator';
    separator.setAttribute('aria-hidden', 'true');
    separator.textContent = '/';

    link.className = 'navigation-breadcrumbs__link';
    if (previewThemeId) {
      const returnUrl = new URL(sourceUrl, window.location.origin);
      returnUrl.searchParams.set('preview_theme_id', previewThemeId);
      returnUrl.searchParams.set('view', 'collection-navigation');
      link.href = `${returnUrl.pathname}${returnUrl.search}`;
    } else {
      link.href = sourceUrl;
    }

    link.textContent = sourceTitle;

    if (existingParent) {
      existingParent.replaceChildren(link);
      return;
    }

    sourceItem.appendChild(link);
    currentItem.before(sourceItem, separator);
  });
})();
